module.exports = __webpack_public_path__ + "media/images/default/pages/homepage/patient_recommends/3-f6951420f63a83e20e0b538c5a9d1d25.svg";